/* Elemental Wear — lazysizes-style image loading, 1:1 with neptun2021.de (Prestige + lazysizes).
   An <img data-ew-lazy data-srcset=… data-src=…> gets its real src/srcset only when it comes within `expand` px of the
   screen: data-expand if set (neptun's product gallery: -100 = 100px INSIDE the screen), otherwise 370px, or 500px when
   the screen is over 500px both ways (lazysizes' default, measured on neptun). The image's own onload then adds
   .is-loaded and its CSS fade runs where the viewer can see it. Images added later (search, cart) are picked up too.
   window.ewLazy.watch(img) / .load(img) for scripts that decide per breakpoint (assets/ew-product.js). */
(() => {
  const defExpand = () => (innerHeight > 500 && innerWidth > 500 ? 500 : 370);
  const load = (img) => {
    if (!img.hasAttribute('data-ew-lazy')) return;
    img.removeAttribute('data-ew-lazy');
    if (img.dataset.srcset) img.srcset = img.dataset.srcset;
    if (img.dataset.src) img.src = img.dataset.src;
  };
  const observers = new Map();
  const observer = (m) => {
    if (!observers.has(m)) observers.set(m, new IntersectionObserver((entries, o) => entries.forEach((e) => {
      if (e.isIntersecting) { o.unobserve(e.target); load(e.target); }
    }), { rootMargin: m + 'px' }));
    return observers.get(m);
  };
  const watch = (img) => {
    if (img.__ewLazy || !img.hasAttribute('data-ew-lazy')) return;
    img.__ewLazy = true;
    if (!('IntersectionObserver' in window)) return load(img);
    observer(img.dataset.expand != null ? +img.dataset.expand : defExpand()).observe(img);
  };
  const scan = (root) => root.querySelectorAll && root.querySelectorAll('img[data-ew-lazy]:not([data-ew-lazy-manual])').forEach(watch);
  window.ewLazy = { watch, load };
  const start = () => {
    scan(document);
    new MutationObserver((ms) => ms.forEach((m) => m.addedNodes.forEach((n) => {
      if (n.nodeType !== 1) return;
      if (n.matches('img[data-ew-lazy]:not([data-ew-lazy-manual])')) watch(n); else scan(n);
    }))).observe(document.documentElement, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
